import armenia from "../presentation/armenia.pptx";
import Azerbaijan from "../presentation/azerb.pptx";
import belarus from "../presentation/belarus.pdf";
import georgia from "../presentation/georgia.pptx";
import kitay from "../presentation/kitay.pptx";
import luige from "../presentation/luige.pptx";
import politex from "../presentation/politex.pptx";
import serbia from "../presentation/serbia.pptx";
import tajik from "../presentation/tajik.pdf";
import uzbek from "../presentation/uzb.pptx";
import vengria from "../presentation/vengria.pptx";
import rus from "../presentation/rus.pdf";
import kazak from "../presentation/kazak.pdf";
import kuhar from "../presentation/kuhar.pptx";
import laykam from "../presentation/laykam.pptx";
//eng
import armeniaEng from "../presentation/armeniaEng.pdf";
import azerbEng from "../presentation/azerEng.pdf";
import luigeEng from "../presentation/luigeEng.pdf";
import gruziaEng from "../presentation/gruziaEng.pdf";
import kazakEng from "../presentation/kazakEng.pdf";
import serbiaEng from "../presentation/serbiaEng.pptx";

import belarusEng from "../presentation/belarusEng.pdf";
import vengriaEng from "../presentation/vengriaEng.pptx";
import kitayEng from "../presentation/kitayEng.pptx";
import tajikEng from "../presentation/tajikEng.ppt";
import uzbEng from "../presentation/uzbEng.pptx";
import politexEng from "../presentation/politexEng.pdf";
import rusEng from "../presentation/rusEng.pdf";
import laykamEng from "../presentation/laykamEng.pdf";


export const translations = {
  download: {
    ru: "📥 Скачать презентацию",
    en: "📥 Download presentation",
    kg: "📥 Презентацияны жүктөө",
  },
  ru: {
    heroTitle:
      "МОДЕРНИЗАЦИЯ СТАТИСТИЧЕСКИХ БИЗНЕС-ПРОЦЕССОВ: ФОРМИРОВАНИЕ НОВОЙ ЭКОСИСТЕМЫ ОФИЦИАЛЬНОЙ СТАТИСТИКИ",
    heroSubtitle: "Международный форум",
    heroDesc: "",
    aboutBtn: "О форуме",
    aboutTitle: "О юбилее",
  },

  en: {
    heroTitle:
      "Modernization of Statistical Business Processes: Establishment of a New Official Statistics Ecosystem",
    heroSubtitle: "International forum",
    heroDesc: "",
    aboutBtn: "About Forum",
    aboutTitle: "About Anniversary",
  },

  kg: {
    heroTitle:
      "СТАТИСТИКАЛЫК БИЗНЕС-ПРОЦЕССТЕРДИ МОДЕРНИЗАЦИЯЛОО: РАСМИЙ СТАТИСТИКАНЫН ЖАҢЫ ЭКОСИСТЕМАСЫН КАЛЫПТАНДЫРУУ",
    heroSubtitle: "Эл аралык форум",
    heroDesc: "",
    aboutBtn: "Форум жөнүндө",
    aboutTitle: "Юбилей жөнүндө",
  },
  aboutTitle: {
    ru: "100 лет статистике Кыргызстана",
    en: "100 Years of Statistics in Kyrgyzstan",
    kg: "Кыргызстан статистикасына 100 жыл",
  },

  aboutSubtitle: {
    ru: "Век развития, доверия и цифровых преобразований",
    en: "A century of development, trust and digital transformation",
    kg: "Өнүгүүнүн, ишенимдин жана санарип өзгөрүүлөрдүн доору",
  },

  aboutTexts: {
    ru: [
      "Национальный статистический комитет Кыргызской Республики отмечает 100-летний юбилей — важную веху развития государственной статистики.",
      "За столетие статистика прошла путь от традиционных методов к цифровым решениям и искусственному интеллекту.",
      "Юбилейный форум станет площадкой для международного сотрудничества и обмена опытом.",
    ],
    en: [
      "The National Statistical Committee of the Kyrgyz Republic celebrates its 100th anniversary — a key milestone in the development of official statistics.",
      "Over a century, statistics has evolved from traditional methods to digital solutions and artificial intelligence.",
      "The anniversary forum will serve as a platform for international cooperation and knowledge exchange.",
    ],
    kg: [
      "Кыргыз Республикасынын Улуттук статистика комитети 100 жылдык мааракесин белгилейт.",
      "Статистика салттуу ыкмалардан санариптик чечимдерге чейин өнүктү.",
      "Форум эл аралык кызматташуу үчүн аянтча болот.",
    ],
  },
  programTitle: {
    ru: "Программа форума",
    en: "Forum Program",
    kg: "Форумдун программасы",
  },

  moderator: {
    ru: "Модератор",
    en: "Moderator",
    kg: "Модератор",
  },

  venueTitle: {
    ru: "Место проведения",
    en: "Venue",
    kg: "Өтүү жери",
  },

  venueCity: {
    ru: "Государственная резиденция Президента Кыргызской Республики",
    en: "State Residence of the President of the Kyrgyz Republic",
    kg: "Кыргыз Республикасынын Президентинин Мамлекеттик резиденциясы",
  },

  venueAddress: {
    ru: "ул. Семетей, 1, г. Бишкек",
    en: "1 Semetey St, Bishkek",
    kg: "Семетей көчөсү, 1, Бишкек шаары",
  },
  footerTitle: {
    ru: "Национальный статистический комитет",
    en: "National Statistical Committee",
    kg: "Улуттук статистика комитети",
  },

  footerCountry: {
    ru: "Кыргызская Республика",
    en: "Kyrgyz Republic",
    kg: "Кыргыз Республикасы",
  },

  footerDev: {
    ru: "Разработчик",
    en: "Developer",
    kg: "Иштеп чыгуучу",
  },

  footerCenter: {
    ru: "Центр интеллектуальных данных",
    en: "Center for Intelligent Data",
    kg: "Интеллектуалдык маалымат борбору",
  },
};

export const programData = {
  ru: [
    {
      time: "10:30 – 11:00",
      title: "Официальное открытие форума",
      moderator: "",
      speakers: [
        {
          name: "Кудайбергенов Бактыбек Жапарович",
          desc: "Председатель Национального статистического комитета Кыргызской Республики",
        },
        {
          name: "Амангельдиев Данияр Джолдошевич",
          desc: "Первый заместитель Председателя Кабинета Министров Кыргызской Республики",
        },
        {
          name: "Трефилов Денис Анатольевич",
          desc: "Заместитель Генерального секретаря СНГ",
        },
        {
          name: "Шантану Мукхерджи",
          desc: "И.о. Директора Статистического отдела ООН (видео-обращение)",
        },
        // {
        //   name: "Иманалиев Данияр Шаршенбекович",
        //   desc: "Член Коллегии (Министр) ЕЭК",
        // },
        {
          name: "Лайкам Константин Эмильевич",
          desc: "Председатель Межгосударственного статистического комитета СНГ",
        },
        {
          name: "Антье Граве",
          desc: "Постоянный Координатор ООН в Кыргызской Республике",
        },
        {
          name: "Хью Ридделл",
          desc: "Глава представительства Группы Всемирного банка в Кыргызской Республике",
        },
      ],
    },

    {
      time: "11:00 – 12:00",
      title: "Панельная сессия 1",
      subtitle:
        "Современные национальные статистические системы: процессный подход и модернизация статистического производства",
      moderator: "Кудайбергенов Бактыбек Жапарович",
      moderatorTopic:
        "Председатель Национального статистического комитета Кыргызской Республики",
      speakers: [
        {
          name: "Мнацаканян Степан Левонович",
          desc: "Президент Статистического комитета Республики Армения",
          topic: "Стандарты и модели модернизации в Армстате",
          file: armenia,
        },
        {
          name: "Галкин Сергей Сергеевич",
          desc: "Руководитель Федеральной службы государственной статистики Российской Федерации",
          topic:
            "Стратегические вызовы развития официальной статистики в Российской Федерации",
          file: rus,
        },

        {
          name: "Мамедов Вахаб Фейруз оглы",
          desc: "Первый заместитель председателя Государственного Комитета по Статистике Азербайджанской Республики",
          topic:
            "Национальная статическая система Азербайджана:основные направление модернизации статического производства",
          file: Azerbaijan,
        },

        {
          name: "Тиина Луиге",
          desc: "Директор Статистического отдела ЕЭК ООН",
          topic: "Тенденции в модернизации официальной статистики",
          file: luige,
        },
        {
          name: "Керималиева Назира Керималиевна",
          desc: "Первый заместитель Председателя Национального статистического комитета Кыргызской Республики",
          topic:
            "Модернизация статистической системы Кыргызской Республики:вызовы и достижения",
        },
      ],
    },

    {
      time: "12:00 – 13:00",
      title: "Панельная сессия 2",
      subtitle:
        "Цифровые технологии и искусственный интеллект в ответ на растущий спрос на статистические данные",
      moderator: "Тиина Луиге",
      moderatorTopic:
        "Директор Статистического отдела Европейской экономической комиссии ООН (ЕЭК ООН)",
      speakers: [
        {
          name: "Лайкам Константин Эмильевич",
          desc: "Председатель Межгосударственного Статкомитета СНГ",
          topic: "Создание AI-ready статистики",
          file: laykam,
        },
        {
          name: "Гогита Тодрадзе",
          desc: "Исполнительный директор Национальной статистической службы Грузии",
          topic:
            "Трансформационный путь Грузии в развитии официальной статистики",
          file: gruziaEng,
        },
        {
          name: "Турлубаев Максат Кайратович",
          desc: "Руководитель Бюро национальной статистики  агентства по стратегическому планированию и реформам Республики Казахстана",
          topic:
            "Цифровые решения с использованием ИИ в официальной статистике Казахстана",
          file: kazak,
        },

        {
          name: "Бранко Йосипович",
          desc: "Директор Статистического управление Республики Сербия",
          topic:
            "Цифровые технологии и искуственный интеллект: укрепление доверия, доступности и поддержки принятия решений ",
          file: serbia,
        },
        {
          name: "Кухаревич Елена Ивановна",
          desc: "Заместитель директора Департамента статистики Евразийской экономической комиссии",
          topic: "Статистика ЕАЭС в эпоху ИИ: вызовы, адаптация, перспективы",
          file: kuhar,
        },
      ],
    },

    {
      time: "14:00 – 15:00",
      title: "Панельная сессия 3",
      subtitle:
        "Интеграция новых источников данных: административные, альтернативные и большие данные",
      moderator: "Лайкам Константин Эмильевич",
      moderatorTopic:
        "Председатель Межгосударственного статистического комитета СНГ",
      speakers: [
        {
          name: "Нурмахмадзода Джамшед",
          desc: "Директор Агентства по статистике при Президенте Республики Таджикистан",
          topic:
            "Интеграция новых источников данных в официальную статистику: роль электронной торговли в формировании современной статической системы Республики Таджикистан",
          file: tajik,
        },
        {
          name: "Жигарев Тимофей Петрович",
          desc: "Первый заместитель Председателя Национального статистического комитета Республики Беларусь",
          topic:
            "Построение архитектуры статистического производства через управлние государственнымы данными",
          file: belarus,
        },
        {
          name: "Мирсоатов Лазизжон",
          desc: "Заместитель Председателя Национального комитета Республики Узбекистан по статистике",
          topic:
            "Информационные системы в Национальной статистической системе Узбекистана",
          file: uzbek,
        },
        {
          name: "Пал Бодай",
          desc: "Советник президента Центрального статистического управления Венгрии",
          topic:
            "Виртуальная Венгрия-Взаимосвязь статистических и административных баз данных",
          file: vengria,
        },
        {
          name: "Лу Шань",
          desc: "Главный методолог Национального бюро статистики Китая",
          topic:
            "Использование и перспективы новых источников данных в государственной статистике Китая",
          file: kitay,
        },
      ],
    },

    {
      time: "15:00 – 15:50",
      title: "Панельная сессия 4",
      subtitle:
        "Развитие статистического потенциала: кадры, институциональная устойчивость и международное сотрудничество",
      moderator: "Турлубаев Максат Кайратович",
      moderatorTopic:
        "Руководитель Бюро национальной статистики Агентства по стратегическому планированию и реформам Республики Казахстан",
      speakers: [
        {
          name: "Антье Граве",
          desc: "Постоянный Координатор ООН в Кыргызской Республике",
          topic: "Данные для достижения ЦУР",
        },
        {
          name: "Хью Ридделл",
          desc: "Глава представительства Группы Всемирного банка в Кыргызской Республике",
          topic:
            "Укрепление партнерства в целях модернизации системы официальной статистики",
        },
        // { name: "Лайкам Константин Эмильевич", desc: "СНГ" },
        {
          name: "Чыныбаев Мирлан Койчубекович",
          desc: "Ректор Кыргызского  Государственного Технического Университета имени И. Раззакова",
          topic: "Современные тенденции инженерного образование",
          file: politex,
        },
        {
          name: "Сейдахматова Салия Зоданбековна",
          desc: "Директор Института статистических исследований и повышения квалификации Национального статистического комитета Кыргызской Республики ",
          topic:
            "Важность повышения потенциала для устойчивого развития статистической системы",
        },
      ],
    },
  ],

  en: [
    {
      time: "10:30 – 11:00",
      title: "Official opening of the forum",
      moderator: "",
      speakers: [
        {
          name: "Mr. Baktybek Kudaibergenov",
          desc: "Chairman of the National Statistical Committee of the Kyrgyz Republic",
        },
        {
          name: "Mr. Amangeldiev Daniyar Dzholdoshevich",
          desc: "First Deputy Chairman of the Cabinet of Ministers (to be confirmed)",
        },
        {
          name: "Mr. Trefilov Denis Anatolyevich",
          desc: "Deputy Secretary General of the CIS",
        },
        {
          name: "Mr. Shantanu Mukherjee",
          desc: "UN Statistics Division (video speech)",
        },
        // {
        //   name: "Mr. Imanaliev Daniiar Sharshenbekovich",
        //   desc: "EEC Minister",
        // },
        {
          name: "Mr. Laykam Konstantin Emilievich",
          desc: "CIS Statistical Committee",
        },
        { name: "Ms. Antje Grawe", desc: "UN Resident Coordinator" },
        { name: "Mr. Hugh Riddell", desc: "World Bank Country Manager" },
      ],
    },

    {
      time: "11:00 – 12:00",
      title: "Session 1",
      subtitle:
        "Modern national statistical systems: process approach and modernization of statistical production",
      moderator: "Mr. Kudaibergenov Baktybek Zhaparovich",
      moderatorTopic: "",
      speakers: [
        {
          name: "Mr. Mnatsakanyan Stepan Levonovich",
          desc: "President of the Statistical Committee of Armenia",
          topic: "Standards and modernization models in Armstat",
          file: armeniaEng,
        },
        {
          name: "Mr. Galkin Sergey Sergeevich",
          desc: "Head of Rosstat",
          topic:
            "Strategic challenges of official statistics development in the Russian Federation",
          file: rusEng,
        },
        {
          name: "Mr. Vahab Mammadov",
          desc: "First Deputy Chairman of the State Statistical Committee of the Republic of Azerbaijan",
          topic:
            "National statistical system of Azerbaijan: main directions for the modernization of statistical production",
          file: azerbEng,
        },
        {
          name: "Ms. Tiina Luige",
          desc: "Director of Statistical Division of the United Nations Economic Commission for Europe (UNECE)",
          topic: "Trends in Modernization of Official Statistics",
          file: luigeEng,
        },
        {
          name: "Ms. Nazira Kerimalieva",
          desc: "First Deputy Chairman of the National Statistical Committee of the Kyrgyz Republic",
          topic:
            "Modernization of the statistical system of the Kyrgyz Republic:challenges and achievements",
        },
      ],
    },

    {
      time: "12:00 – 13:00",
      title: "Session 2",
      subtitle:
        "Digital technologies and AI in response to growing demand for data",
      moderator: "Ms. Tiina Luige",
      moderatorTopic:
        "Director of Statistical Division of the United Nations Economic Commission for Europe (UNECE)",
      speakers: [
        {
          name: "Mr. Laykam Konstantin Emilievich ",
          desc: "Chairman of the Interstate Statistical Committee of the Commonwealth of Independent States",
          topic: "Creating AI-ready statistics in CIS-Stat».",
          file:laykamEng
        },
        {
          name: "Mr. Gogita Todradze",
          desc: "Executive Director of the National Statistical Service of Georgia.",
          topic:
            "Georgia’s Transformative Journey in Developing Official Statistics",
          file: gruziaEng,
        },
        {
          name: "Mr. Maksat Turlubaev Kairatovich ",
          desc: "Head of the Bureau of National Statistics of the Agency for Strategic Planning and Reforms of the Republic of Kazakhstan ",
          topic:
            "Digital solutions using AI in official statistics of Kazakhstan",
          file: kazakEng,
        },

        {
          name: "Mr. Branko Josipović",
          desc: "Director of the Statistical Office of the Republic of Serbia",
          topic:
            "Digital Technologies and Artificial Intelligence: Strengthening Trust, Accessibility and Decision Support",
          file: serbiaEng,
        },
        {
          name: "Ms. Elena Kukharevich",
          desc: "Deputy Director of the Statistics Department of the Eurasian Economic Commission ",
          topic:
            "Eurasian Economic Union Statistics in the Age of AI: Challenges, Adaptation and Prospects",
          file: kuhar,
        },
      ],
    },

    {
      time: "14:00 – 15:00",
      title: "Session 3",
      subtitle:
        "Integration of new data sources: administrative, alternative and big data",
      moderator: "Mr. Laykam Konstantin Emilievich",
      moderatorTopic:
        "Chairman of the Interstate Statistical Committee of the Commonwealth of Independent States",
      speakers: [
        {
          name: "Mr. Nurmahmadzoda Jamshed",
          desc: "Director of the Agency on Statistics under the President of the Republic of Tajikistan",
          topic:
            "Integration of new data sources into the official statistics: the role of e-commerce in the formation of a modern statistical system in the Republic of Tajikistan",
          file: tajikEng,
        },
        {
          name: "Mr. Zhyharau Tsimafei Petrovich",
          desc: "First Deputy Chairperson of the National Statistical Committee of the Republic of Belarus ",
          topic:
            "Building the architecture of statistical production through the government data management",
          file: belarusEng,
        },
        {
          name: "Mr. Mirsoatov Lazizjon",
          desc: "Deputy Chairman of the National Statistics Committee of the Republic of Uzbekistan ",
          topic:
            "Information systems in the National Statistical System of Uzbekistan",
          file: uzbEng,
        },
        {
          name: "Mr. Pal Boday",
          desc: "Adviser of President of the Hungarian Central Statistical Office",
          topic:
            "Virtual Hungary - Interlinkage of statistical and administrative databases",
          file: vengriaEng,
        },
        {
          name: "Mr. Lu Shan",
          desc: ", Chief Methodologist of the National Bureau of Statistics of China ",
          topic:
            "Application and Prospects of New Data Sources in China’s Government Statistics",
          file: kitayEng,
        },
      ],
    },

    {
      time: "15:00 – 15:50",
      title: "Session 4",
      subtitle:
        "Statistical capacity building: human resources and cooperation",
      moderator: "Mr. Maxat Turlubayev",
      moderatorTopic:
        "Head of the Bureau of National Statistics of the Agency for Strategic Planning and Reforms of the Republic of Kazakhstan ",
      speakers: [
        {
          name: "Ms. Antje Grawe",
          desc: "the UN Resident Coordinator in the Kyrgyz Republic",
          topic: "Data for SDGs",
        },
        {
          name: "Mr. Hugh Riddell",
          desc: "World Bank Group Country Manager for the Kyrgyz Republic ",
          topic:
            "Strengthening the Partnership to Modernize the Official Statistics System",
        },
        // {
        //   name: "Mr. Laykam Konstantin Emilievich",
        //   desc: "Chairman of the Interstate Statistical Committee of the Commonwealth of Independent States ",
        // },
        {
          name: "Mr. Chynybaev Mirlan Koichubekovich",
          desc: "Rector of the Kyrgyz State Technical University named after I. Razzakov ",
          topic: "Modern Trends in the Engineering Education",
          file: politex,
        },
        {
          name: "Ms. Salia Seidahmatova",
          desc: "Director of the Institute of Statistical Researches and Capacity Building of the National Statistical Committee of the Kyrgyz Republic",
          topic:
            "The importance of the capacity building for sustainable development of statistical system",
        },
      ],
    },
  ],

  kg: [
    {
      time: "10:30 – 11:00",
      title: "Форумдун расмий ачылышы",
      moderator: "",
      speakers: [
        {
          name: "Кудайбергенов Бактыбек Жапарович",
          desc: "Кыргыз Республикасынын Улуттук статистика комитетинин төрагасы",
        },
        {
          name: "Амангельдиев Данияр",
          desc: "Кыргыз Республикасынын Министрлер Кабинетинин Төрагасынын биринчи орун басары ",
        },
        { name: "Трефилов Денис", desc: "КМШнын Башкы катчысынын орун басары" },
        {
          name: "Шантану Мукхерджи",
          desc: "БУУнун Статистика бөлүмүнүн директорунун милдетин аткаруучу (видео-кайрылуу)",
        },
        {
          name: "Иманалиев Данияр",
          desc: "Евразия экономикалык комиссиясынын Интеграция жана макроэкономика боюнча Коллегиясынын мүчөсү (Министр)",
        },
        {
          name: "Лайкам Константин",
          desc: "КМШнын Мамлекеттер аралык статистика комитетинин төрагасы",
        },
        {
          name: "Антье Граве",
          desc: "Бириккен Улуттар Уюмунун Кыргыз Республикасындагы тутумунун Туруктуу Координатору",
        },
        {
          name: "Хью Ридделл",
          desc: "Дүйнөлүк банктын тобунун Кыргыз Республикасындагы өкүлчүлүгүнүн башчысы",
        },
      ],
    },

    {
      time: "11:00 – 12:00",
      title: "1-панелдик сессия",
      subtitle: "Заманбап улуттук статистикалык системалары",
      moderator: "Кудайбергенов Бактыбек Жапарович ",
      moderatorTopic:
        "Кыргыз Республикасынын Улуттук статистикалык комитетинин төрагасы.",
      speakers: [
        {
          name: "Мнацаканян Степан Левонович",
          desc: "Армения Республикасынын Статистика комитетинин президенти ",
          topic: "Армстатты модернизациялоонун стандарттары жана моделдери",
          file: armenia,
        },
        {
          name: "Галкин Сергей Сергеевич",
          desc: "Россия Федерациясынын Мамлекеттик статистика федералдык кызматынын жетекчиси",
          topic:
            "Россия Федерациясындагы расмий статистиканы өнүктүрүүнүн стратегиялык чакырыктары",
        },
        {
          name: "Мамедов Вахаб Фейруз оглы",
          desc: "Азербайжан Республикасынын Мамлекеттик статистика комитетинин төрагасынын биринчи орун басары",
          topic:
            "Азербайжандын улуттук статистикалык тутуму: статистикалык өндүрүштү модернизациялоонун негизги багыттары",
          file: Azerbaijan,
        },

        {
          name: "Тиина Луиге",
          desc: "БУУнун Европа экономикалык комиссиясынын (БУУ ЕЭК) Статистика бөлүмүнүн директору ",
          topic: "Расмий статистиканы модернизациялоодогу тенденциялар",
          file: luige,
        },
        {
          name: "Керималиева Назира Керималиевна",
          desc: "Кыргыз Республикасынын Улуттук статистика комитетинин төрагасынын биринчи орун басары",
          topic:
            "Кыргыз Республикасынын статистикалык тутумун   модернизациялоо: чакырыктар жана жетишкендиктер",
        },
      ],
    },

    {
      time: "12:00 – 13:00",
      title: "2-панелдик сессия",
      subtitle:
        "Статистикалык маалыматтарга болгон суроо-талаптын өсүшүнө жооп катары санариптик технологиялар жана жасалма интеллект",
      moderator: "Тиина Луиге ",
      moderatorTopic:
        "БУУнун Европа экономикалык комиссиясынын (БУУ ЕЭК) Статистика бөлүмүнүн директору",
      speakers: [
        {
          name: "Лайкам Константин Эмильевич",
          desc: "КМШнын Мамлекеттер аралык статистикалык комитетинин төрагасы ",
          topic: "КМШ Статкомитетинде AI-ready  статистикасын түзүү",
        },
        {
          name: "Гогита Тодрадзе",
          desc: "Грузиянын Улуттук статистикалык кызматынын аткаруучу директору.",
          topic:
            "Расмий статистиканы өнүктүрүүдөгү Грузиянын трансформациялык жолу",
          file: georgia,
        },
        {
          name: "Турлубаев Максат Кайратович",
          desc: "Казакстан Республикасынын Стратегиялык пландаштыруу жана реформалар агенттигинин Улуттук статистика бюросунун жетекчиси",
          topic:
            "Казакстандын расмий статистикасында жасалма интеллектти колдонуу менен санариптик чечимдер",
        },

        {
          name: "Бранко Йосипович",
          desc: "Сербия Республикасынын Статистика башкармалыгынын директору ",
          topic:
            "Санариптик технологиялар жана жасалма интеллект: Ишенимди, жеткиликтүүлүктү бекемдөө жана чечимдерди кабыл алууну колдоо",
          file: serbia,
        },
        {
          name: "Кухаревич Елена Ивановна",
          desc: "Евразия экономикалык комиссиясынын статистика Департаментинин директорунун орун басары",
          topic:
            "ЖИ доорундагы ЕАЭБ статистикасы: чакырыктар, адаптация жана перспективалар",
        },
      ],
    },

    {
      time: "14:00 – 15:00",
      title: "3-панелдик сессия",
      subtitle:
        "Маалыматтардын жаңы булактарын интеграциялоо: административдик, альтернативдик жана чоң маалыматтар",
      moderator: "Лайкам Константин Эмильевич ",
      moderatorTopic:
        "КМШнын Мамлекеттер аралык статистикалык комитетинин төрагасы.",
      speakers: [
        {
          name: "Нурмахмадзода Джамшед",
          desc: "Тажикстан Республикасынын Президентине караштуу Статистика агенттигинин директору",
          topic:
            "Расмий статистикага маалыматтардын жаңы булактарын интеграциялоо: Тажикстан Республикасынын заманбап статистикалык тутумун калыптандырууда электрондук сооданын ролу",
          file: tajik,
        },
        {
          name: "Жигарев Тимофей Петрович",
          desc: "Беларусь Республикасынын Улуттук статистикалык комитетинин төрагасынын биринчи орун басары ",
          topic:
            "Мамлекеттик маалыматтарды башкаруу аркылуу статистикалык өндүрүштүн архитектурасын куруу",
          file: belarus,
        },
        {
          name: "Мирсоатов Лазизжон Туйчибой угли",
          desc: "Өзбекстан Республикасынын Улуттук статистика комитетинин төрагасынын орун басары ",
          topic:
            "Өзбекстандын улуттук статистикалык тутумундагы маалыматтык системалар",
          file: uzbek,
        },
        {
          name: "Пал Бодай",
          desc: "Венгриянын Борбордук статистика башкармалыгынын президентинин кеңешчиси",
          topic:
            "Виртуалдык Венгрия – Статистикалык жана административдик маалыматтар базаларынын өз ара байланышы",
          file: vengria,
        },
        {
          name: "Лу Шань",
          desc: "Кытай Улуттук статистика бюросунун башкы методологу",
          topic:
            "Кытайдын мамлекеттик статистикасында маалыматтардын жаңы булактарын колдонуу жана келечеги",
        },
      ],
    },

    {
      time: "15:00 – 15:50",
      title: "4-панелдик сессия",
      subtitle:
        "Статистикалык потенциалды өнүктүрүү: кадрлар, институционалдык туруктуулук жана эл аралык кызматташтык",
      moderator: "Турлубаев Максат Кайратович",
      moderatorTopic:
        "Казакстан Республикасынын Стратегиялык пландаштыруу жана реформалар агенттигинин Улуттук статистика бюросунун жетекчиси",
      speakers: [
        {
          name: "Антье Граве",
          desc: "БУУ тутумунун Кыргыз Республикасындагы туруктуу Координатору",
          topic: "Туруктуу өнүгүү максаттарын жетүү үчүн маалыматтар",
        },
        {
          name: "Хью Ридделл",
          desc: "Дүйнөлүк банк тобунун Кыргыз Республикасындагы өкүлчүлүгүнүн башчысы",
          topic:
            "Расмий статистика тутумун модернизациялоо максатында өнөктөштүктү бекемдөө",
        },
        {
          name: "Чыныбаев Мирлан",
          desc: "И. Раззаков атындагы Кыргыз мамлекеттик техникалык университетинин ректору",
          topic: "Инженердик билим берүүнүн заманбап тенденциялары",
          file: politexEng,
        },
        // {
        //   name: "Лайкам Константин",
        //   desc: "КМШнын Мамлекеттер аралык статистикалык комитетинин төрагасы ",
        // },
        {
          name: "Сейдахматова Салия Зоданбековна",
          desc: "Кыргыз Республикасынын Улуттук статистика комитетинин Статистикалык изилдөөлөр жана квалификацияны жогорулатуу институтунун директору",
          topic:
            "Статистикалык тутумдун туруктуу өнүгүүсү үчүн потенциалды жогорулатуунун маанилүүлүгү",
        },
      ],
    },
  ],
};
